// @flow
import OfficeDetail from './OfficeDetailLoader'
export default OfficeDetail
